<template>
<div v-if="oidcIsAuthenticated">
  <h1>Change Password</h1>
  <div class="input_container">
    <div class="checkmark_container" v-bind:class="{ show_checkmark: valid_password }">
      <svg width="50%" height="50%" viewBox="0 0 140 100">
        <path class="checkmark" v-bind:class="{ checked: valid_password }" d="M10,50 l25,40 l95,-70" />
      </svg>
    </div>

    <p><label for="oldPassword">Old Password</label></p>
    <div><input v-model="oldPassword" type="password" placeholder="Old password" name="oldPasword" /></div>

    <p><label for="newPassword">New Password</label></p>
    <div><input type="password" v-model="password" autocomplete="off" placeholder="New Password" id="newPassword" /></div>

    <p><label for="confirmPassword">Confirm Password</label></p>
    <div><input type="password" v-model="confirmPassword" autocomplete="off" placeholder="Confirm New Password" id="confirmPassword" /></div>

    <ul>
      <li v-bind:class="{ is_valid: valid_old_password }">Valid old password</li>
      <li v-bind:class="{ is_valid: contains_eight_characters }">At least 8 characters</li>
      <li v-bind:class="{ is_valid: contains_number }">Contains number</li>
      <li v-bind:class="{ is_valid: contains_lowercase }">Contains lowercase</li>
      <li v-bind:class="{ is_valid: contains_uppercase }">Contains uppercase</li>
      <li v-bind:class="{ is_valid: contains_special_character }">Contains special character</li>
      <li v-bind:class="{ is_valid: password_match }">Passwords match</li>
    </ul>
  </div>
  <div class="submit_container" v-bind:class="{ show_submit: valid_password }">
    <input class="submitPass" v-on:click="execute" v-bind:class="{ checked: valid_password }" type="submit" value="Submit">
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import CognitoIDSP from 'aws-sdk/clients/cognitoidentityserviceprovider'

var cognito = new CognitoIDSP({
  region: 'eu-west-2'
})

// reference: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
// eslint-disable-next-line
const specialCharPattern = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/
export default {
  name: 'ChangePassword',
  data: function () {
    return {
      password: '',
      oldPassword: '',
      confirmPassword: ''
    }
  },
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcAccessToken'
    ]),
    valid_old_password: function () {
      if (this.oldPassword) {
        return this.oldPassword.length >= 8 &&
          /\d/.test(this.oldPassword) &&
          /[a-z]/.test(this.oldPassword) &&
          /[A-Z]/.test(this.oldPassword) &&
          specialCharPattern.test(this.oldPassword)
      } else {
        return false
      }
    },
    password_length: function () { return this.password ? this.password.length : 0 },
    contains_eight_characters: function () { return this.password_length >= 8 },
    contains_number: function () { return /\d/.test(this.password) },
    contains_lowercase: function () { return /[a-z]/.test(this.password) },
    contains_uppercase: function () { return /[A-Z]/.test(this.password) },
    contains_special_character: function () {
      return specialCharPattern.test(this.password)
    },
    password_match: function () {
      return this.password_length > 0 ? this.password === this.confirmPassword : false
    },
    valid_password: function () {
      return this.valid_old_password &&
        this.contains_eight_characters &&
        this.contains_special_character &&
        this.contains_lowercase &&
        this.contains_uppercase &&
        this.contains_number &&
        this.password_match
    }
  },
  methods: {
    execute: function () {
      var changePasswordParam = {
        AccessToken: this.oidcAccessToken,
        PreviousPassword: this.oldPassword,
        ProposedPassword: this.password
      }
      var that = this
      cognito.changePassword(changePasswordParam, function (err, data) {
        if (err) {
          if (err.code === 'InvalidParameterException') {
            alert('Some parameters seem to be in valid. Please double check.')
          } else if (err.code === 'InvalidPasswordException' || err.code === 'NotAuthorizedException') {
            alert('Your password was wrong. Please try again.')
          } else {
            alert('Your password could not be changed. Please try again later.')
          }
          // eslint-disable-next-line
          console.log('Error code: ' + err.code)
        } else {
          alert('Password changed')
          that.$router.push('/')
        }
      })
    }
  }
}
</script>
<style>
</style>
